const reactivationStrings = {
  reactivation: {
    reactivationTitle: 'Ready to open a new account?',
    reactivationDescription:
      'Open a Varo account to enjoy benefits that help you manage your money and get ahead.',
    closedTitle: 'Your account has been closed',
    closedDescription:
      'Closed accounts have limited access. Here’s what you can do:',
    reviewTitle: 'Your application is under review',
    reviewDescription:
      'We’ll send you an email if we need additional information.',
    verifyTitle: 'We need a little more info',
    verifyDescription: `To complete your application, we'll need to verify your ID. This helps us keep your account secure.`,
    buttons: {
      applyNow: 'Apply now',
      verify: 'Verify',
      viewStatements: 'View Statements',
      taxStatements: 'View Tax Statements',
      editMailAddress: 'Edit address',
      logOut: 'Log out',
    },
  },
  reviewInfo: {
    reviewInfoTitle: 'Review your information',
    reviewInfoDescription:
      'Double-check that the information we have on file is accurate',
    validationErrorMessage: 'All fields are required',
    errorTitle: 'Something went wrong',
    errorMessageBody:
      'We’re having trouble getting your information. Please try again.',
    buttons: {
      next: 'Next',
      retry: 'Retry',
      cancel: 'Cancel',
    },
  },
  verifySms: {
    secondaryButton: 'I don’t have a access to that number',
    error: {
      title: 'Something went wrong',
      messageBody: 'Please try again',
      retryButton: 'Retry',
      cancelButton: 'Cancel',
    },
  },
  contactSupport: {
    title: 'We’re ready to help ',
    description:
      'If you no longer have access to that phone number, let our team know your previous account was closed and you’d like to open a new one.',
    listItem: {
      title: 'Contact support',
    },
    inlineAlert: {
      title: 'Hours of operation',
      description: '7:00 AM - 8:30 PM ET',
    },
  },
  personalInfo: {
    buttons: {
      save: 'Save',
    },
  },
  verifySsn: {
    title: 'Verify your identity',
    description:
      'Enter your social security number or individual taxpayer ID. This won’t impact your credit score.',
    inputLabel: 'SSN or ITIN',
    nextButton: 'Next',
    requiredFieldError: 'This field is required',
    minRequiredError: 'Must be at least 9 characters',
    errorTitle: 'Something went wrong',
    errorMessageBody: 'Please try again',
    retryButton: 'Retry',
    cancelButton: 'Cancel',
    ssnMismatchError:
      'The number or ID provided does not match our records. Please try again.',
    infoMessage: 'Your information is encrypted and secured.',
  },
  verifySsnError: {
    title: 'We couldn’t verify your info',
    description:
      'For your security, we’re unable to log you in with the information provided. You can still create a new account using a different email address.',
    signupButton: 'Sign up with new email',
    backToHomeButton: 'Back to home',
    logoutButton: 'Log out',
  },
  reactivationError: {
    title: 'Something went wrong',
    description: 'Please try again later',
    buttons: {
      backToHome: 'Back to home',
    },
  },
};

export default reactivationStrings;
